export default __webpack_public_path__ + "static/media/about-us.134ee434.svg";